import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";


function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.assetList}?organisation=${id}&is_live=1`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On fetching assets:", { error });
        yield put(actionCreators.getFailure(error));
    }
}
function* getSelectedAssets(action) {
    const { options } = action.payload;
    try {
        const url = `${config.api.paths.assetList}`;
        const { data } = yield call(http.authorized.post, url, options);
        yield put(actionCreators.getSelectedAssetSuccess(data));
    } catch (error) {
        logToSentry("On fetching selected assets:", { error });
        yield put(actionCreators.getSelectedAssetFailure(error));
    }
}

function* patch(action) {
    const { asset } = action.payload;
    const url = asset.organisation
        ? `${config.api.paths.assets}${asset.id}/?organisation=${asset.organisation}`
        : `${config.api.paths.assets}${asset.id}/`;
    try {
        const { data } = yield call(http.authorized.patch, url, asset);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On patching asset:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.ASSETS_GET_REQUEST, get),
        takeLatest(actionTypes.GET_SELECTED_ASSET_REQUEST, getSelectedAssets),
        takeLatest(actionTypes.ASSET_PATCH_REQUEST, patch)
    ]);
}
